import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { RouterModule } from '@angular/router';
import { PreferencesComponent } from './pages/preferences/preferences.component';
import { GeneralViewComponent } from './pages/general-view/general-view.component';
import { AccountViewComponent } from './pages/account-view/account-view.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { PreferenceComponent } from './components/preference/preference.component';
import { PreferencesService } from './preferences.service';
import { FormsModule } from '@angular/forms';
import { AlertsViewComponent } from './pages/alerts-view/alerts-view.component';
import { componentinspectionordercomponent } from './components/component-inspection-order/component-inspection-order.component';
import { PipeModule } from '../../shared/pipes/pipe.module';
import { ReportAlertComponent } from './pages/report-alert/report-alert.component';
import { AlertPercentageSettingsPopupComponent } from './pages/Popup/alert-percentage-settings-popup/alert-percentage-settings-popup.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        RouterModule,
    FormsModule,
    PipeModule,
    MatCheckboxModule
    ],
    declarations: [PreferencesComponent, GeneralViewComponent, AccountViewComponent, ChangePasswordComponent, PreferenceComponent, AlertsViewComponent, componentinspectionordercomponent, ReportAlertComponent, AlertPercentageSettingsPopupComponent],
    providers: [
        PreferencesService
    ]
})
export class PreferencesModule { }
